var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66602 0.835938H2.99935C2.64573 0.835938 2.30659 0.976413 2.05654 1.22646C1.80649 1.47651 1.66602 1.81565 1.66602 2.16927V12.8359C1.66602 13.1896 1.80649 13.5287 2.05654 13.7787C2.30659 14.0288 2.64573 14.1693 2.99935 14.1693H10.9993C11.353 14.1693 11.6921 14.0288 11.9422 13.7787C12.1922 13.5287 12.3327 13.1896 12.3327 12.8359V5.5026M7.66602 0.835938L12.3327 5.5026M7.66602 0.835938V5.5026H12.3327",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.60c9bd95840b7db74f24fd7edc6cea41.svg";
export { ForwardRef as ReactComponent };